<template>
  <div>
    <button
      class="btn btn--discrete btn--smallest choosable-gift__btn modal-velociraptor-trigger"
      @click="openModal"
    >
      {{ $t('cart.choosable_gifts.change') }}
    </button>
    <modal :open="isModalOpen" @close="toogleModal('close')">
      <template v-slot:title>
        {{ $t('cart.choosable_gifts.title') }}
      </template>
      <div
        v-if="choosableGiftLoading"
        class="choosable-gift choosable-gift--loading"
      >
        <logo-loading />
      </div>
      <transition name="fade">
        <ul
          v-if="!choosableGiftLoading"
          class="choosable-gift choosable-gift--modal"
        >
          <p v-if="choosableGiftError">
            {{ $t('product.fetch_failed') }}
            <a rel="nofollow" @click.prevent="getChoosableGifts">{{
              $t('product.retry_fetch')
            }}</a>
          </p>
          <choosable-gift
            v-for="gift in choosableGifts"
            v-else
            :key="gift.variant_id"
            :gift="gift"
            :line-item-id="lineItemId"
            :current-variant-id="currentVariantId"
            :new-choosable-gift="newChoosableGift"
            @newVariant="newVariant"
          />
        </ul>
      </transition>
    </modal>
  </div>
</template>

<script>
import ChoosableGift from './choosable-gift/ChoosableGift'
import Modal from '~/components/Modal'
import LogoLoading from '~/components/loadings/logo'

export default {
  components: {
    Modal,
    LogoLoading,
    ChoosableGift,
  },
  props: {
    currentVariantId: {
      type: Number,
      required: true,
    },
    lineItemId: {
      type: Number,
      required: true,
    },
    newChoosableGift: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      isModalOpen: false,
      choosableGiftLoading: false,
      choosableGiftError: false,
      choosableGifts: [],
    }
  },
  methods: {
    toogleModal(action) {
      if (action === 'open') {
        this.getChoosableGifts()
        this.isModalOpen = true
      } else if (action === 'close') {
        this.isModalOpen = false
      }
    },
    openModal() {
      this.$store.dispatch?.('analytics/emitGtagEvent', {
        name: 'click_gift_change',
      })
      this.toogleModal('open')
    },
    newVariant(newVariantId) {
      this.$emit('newVariant', newVariantId)
      this.toogleModal('close')
    },
    async getChoosableGifts() {
      this.choosableGiftLoading = true
      this.choosableGiftError = false

      try {
        const params = {
          ...this.$store.getters.storeInfo,
          line_item_id: this.lineItemId,
        }

        const choosableEndpoint = this.newChoosableGift
          ? 'carts/gift_promotion_options'
          : 'carts/choosable_gifts'

        const { choosable_gifts: choosableGifts } = await this.$axios.$get(
          choosableEndpoint,
          {
            params,
          }
        )

        this.choosableGifts = choosableGifts
      } catch (err) {
        this.choosableGiftError = true
      } finally {
        this.choosableGiftLoading = false
      }
    },
  },
}
</script>

<style lang="scss">
.choosable-gift {
  padding: 0;
  margin: 0;

  &.choosable-gift--loading {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 500px;
    width: 100%;
  }

  &.choosable-gift--cart {
    margin: 0;

    .choosable-gift__item {
      padding: 15px;
      border-bottom: 0;
      border-top: 1px solid $color_gray;
    }
    .choosable-gift__thumbnail {
      flex-shrink: 0;
      width: 90px;
    }
    .choosable-gift__content {
      flex-grow: 1;
      margin: 0 15px;
      max-width: calc(100% - 187px);
    }
    .choosable-gift__title {
      margin-bottom: 5px;
    }

    .choosable-gift__pricing--current {
      background: #ff3ab3;
      color: #e7ef93;
      font-weight: bold;
      text-transform: uppercase;
      padding: 2px 41px 2px 10px;
      display: inline-block;
      font-size: 10px;
      position: relative;
      overflow: hidden;

      &::before {
        content: '';
        width: 16px;
        height: 31px;
        display: block;
        background: #e7ef93;
        position: absolute;
        right: 15px;
        top: 0;
        transform: rotate(20deg);
      }
      &::after {
        height: 100%;
        content: '\e9ea';
        background-color: #e7ef93;
        color: #ff3ab3;
        width: 24px;
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        font-family: linearicons;
        font-style: normal;
        font-weight: 400;
        font-variant: normal;
        text-transform: none;
        line-height: 19px;
        text-indent: 3px;
        -webkit-font-smoothing: antialiased;
      }
    }

    .choosable-gift__btn:focus {
      outline: none;
    }
  }

  &.choosable-gift--modal {
    .modal-velociraptor__body {
      margin-top: 0;
    }

    .choosable-gift__item {
      margin: 0 -15px;
      padding: 15px;
    }

    .choosable-gift__content {
      display: flex;
      justify-content: space-between;
      margin-right: 0;
      width: calc(100% - 99px);
    }

    .choosable-gift__title {
      width: calc(100% - 115px);
      flex-shrink: 0;
      align-self: center;
    }

    .choosable-gift__thumbnail {
      width: 90px;
    }

    .out-of-stock {
      flex-shrink: 0;
      align-self: self-start;
    }

    .choosable-gift__change {
      align-self: center;
    }
  }

  .choosable-gift__item {
    list-style: none;
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px solid $color_gray;
  }

  .choosable-gift__link {
    display: flex;
    width: calc(100% - 50px);
    text-decoration: none;
  }

  .choosable-gift__thumbnail {
    img {
      display: block;
    }
  }

  .choosable-gift__content {
    width: calc(100% - 70px);
    margin: 0 10px;
    flex-wrap: wrap;
  }

  .choosable-gift__title,
  .choosable-gift__pricing {
    display: block;
    font-size: 13px;
    color: #555;
    text-transform: uppercase;
    white-space: nowrap;
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    line-height: 16px;
  }

  .choosable-gift__pricing--previous {
    text-decoration: line-through;
    margin-right: 5px;
  }

  .choosable-gift__pricing--current {
    color: $color_pink;
  }

  .choosable-gift__change {
    align-self: center;
    min-width: 90px;
  }

  .choosable-gift__option {
    color: #333;
    margin-bottom: 0px;
    margin-top: 0px;
  }

  .choosable-gift__selected {
    background-color: #333;
    border-color: white;
    color: white;
  }

  .choosable-gift__btn {
    border-color: #e6e6ea;
    color: #555;
  }
}

@media (min-width: $screen_large) {
  .choosable-gift {
    .choosable-gift__content {
      max-width: calc(100% - 135px);
      margin-right: 10px;
    }

    &.choosable-gift--modal {
      .choosable-gift__item {
        margin: 0 -15px;
        padding: 10px 15px;
      }

      .choosable-gift__content {
        display: flex;
        max-width: 100%;
      }

      .choosable-gift__thumbnail {
        flex-shrink: 0;
      }
    }

    &.choosable-gift--cart {
      .choosable-gift__thumbnail {
        width: 100px;
      }
      .choosable-gift__content {
        max-width: calc(100% - 187px);
      }
    }
  }
}
</style>
